import { Routes } from '@angular/router';
import { BasicDetailsPaneComponent } from './basic-details-pane.component';
import { FilesPaneComponent } from './files-pane.component';
import { LotSourcePaneComponent } from './lot-source-pane.component';
import { LotDetailMainComponent } from './lot-detail-main.component';
import { LotAttributesPaneComponent } from './lot-attributes-pane.component';

export const LOT_DETAIL_ROUTES: Routes = [
    {
        path: 'lot-detail-main/:lotUUID',
        component: LotDetailMainComponent,
        outlet: 'lotDetailPopup',
        children: [
            {
                path: '',
                redirectTo: 'lot-basic-details',
                pathMatch: 'full'
            },
            {
                path: 'lot-basic-details',
                component: BasicDetailsPaneComponent,
                outlet: 'lot-detail-outlet'
            },
            {
                path: 'source',
                component: LotSourcePaneComponent,
                outlet: 'lot-detail-outlet'
            },
            {
                path: 'attributes',
                component: LotAttributesPaneComponent,
                outlet: 'lot-detail-outlet'
            },
            {
                path: 'files',
                component: FilesPaneComponent,
                outlet: 'lot-detail-outlet'
            }
        ]
    }
];
